import LoginContainer from "./loginContainer";
import Login from "./login";
import UserNameLoginFormContainer from "./forms/userNameLoginFormContainer";
import UserNameLoginForm from "./forms/userNameLoginForm";
import UserNameLogin from "./userNameLogin";
import ForgotPassword from "./forgotPassword";
import CheckMail from "./checkMail";
import ResetPasswordForm from "./forms/resetPasswordForm";
import ResetPasswordFormContainer from "./forms/resetPasswordFormContainer";
import ResetPassword from "./resetPassword";
import ForgotPasswordContainer from "./forgotPasswordContainer";
import LoginLayout from "./loginLayout";
import ResetPasswordContainer from "./resetPasswordContainer";
import ForgotPasswordFormContainer from "./forms/forgotPasswordFormContainer";
import BankIdAppLogin from "./bankIdAppLogin";
import StatusMessage from "./statusMessage";
import { AuthEnums } from "models/enums";
import useLoginContext from "./context/useLoginContext";
import LoginContextProvider from "./context/contextProvider";

export {
  LoginContainer,
  Login,
  UserNameLoginForm,
  UserNameLoginFormContainer,
  UserNameLogin,
  ForgotPasswordContainer,
  ForgotPassword,
  CheckMail,
  ResetPasswordContainer,
  ResetPasswordForm,
  ResetPasswordFormContainer,
  ResetPassword,
  LoginLayout,
  ForgotPasswordFormContainer,
  BankIdAppLogin,
  StatusMessage,
  useLoginContext,
  LoginContextProvider,
};

export const loginComponent = {
  [AuthEnums.LoginView.BankIdApp]: BankIdAppLogin,
  [AuthEnums.LoginView.UserNamePassword]: UserNameLogin,
  [AuthEnums.LoginView.ForgotPassword]: ForgotPasswordContainer,
};
